export default __webpack_public_path__ + "static/media/l2.8b3fc14c.jpg";